import { Injectable } from '@angular/core';
import { AUTH_RC, AUTHORIZED_RC } from '@core/constants/routes.constants';
import { AuthApi } from '@core/services/api/auth.api';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class AuthGuard {
  constructor(
    private router: Router,
    private authApi: AuthApi,
    private location: Location
  ) {}

  canMatchUnauthorized(): boolean {
    if (!this.authApi.isAuthorized()) return true;
    this.router.navigate([AUTHORIZED_RC.root]);
    return false;
  }

  canMatchAuthorized(): boolean {
    if (this.authApi.isAuthorized()) return true;

    this.authApi.setRedirectUrl(this.location.path());
    this.router.navigate([AUTH_RC.root]);
    return false;
  }
}
